var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content-header"}),_c('div',{staticClass:"content-wrapper"},[_c('el-row',[_c('el-col',{staticClass:"content-left",attrs:{"span":6}},[_c('IndexMenu',{ref:"indexMenu"})],1),_c('keep-alive',[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }